import debounce from 'lodash/debounce';
import store from '../store';

export default function addResizeListener() {
    store.dispatch('setWindowHeight');
    store.commit('setActiveBreakpoints')
    store.commit('setMobile')

    window.addEventListener(
        'resize',
        debounce(() => {
            store.dispatch('setWindowHeight');
            store.commit('setWindowWidth', window.innerWidth);
            store.commit('setActiveBreakpoints')
            store.commit('setMobile')
        }, 200),
    );
}